import { AppDispatch, RootState } from "../../store";
import { STAGES } from "./stages";
import { actions } from "./slice";
import { PluginContextType } from "../plugin/types";

export const performStage = (pluginContext: PluginContextType) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const globalState = getState();
  const bootstrapState = globalState.bootstrapper;
  if (!bootstrapState.ready) {
    const stage = STAGES[bootstrapState.currentStage];
    if (stage) {
      await Promise.resolve(stage.perform(pluginContext, dispatch, actions, globalState));
    }
  }
};
